<template>
    <div v-if="isFormShown(campaign)">
        <div class="document-embed-unsigned mt-15" :class="{'pdf-container': unsignedDocumentLink}"></div>
        <loader v-if="documentLoading" />
        <button v-if="isFormShown(campaign)" class="button mt-15" :class="isSubmitLoading()" @click="signEdocument(campaign)">
            Review & Sign
        </button>
    </div>
    <div v-else>
        <p class="notification is-success">
            Awesome! You have signed the contract.
        </p>
        <loader v-if="documentLoading" />
        <div class="document-embed-signed mt-15" :class="{'pdf-container': signedDocumentLink}"></div>
    </div>
</template>

<style>
   .pdf-container {
       height: 500px;
   }
</style>

<script>
    import HelloSign from 'hellosign-embedded';
    import PDFObject from '../../../../vendor/pdfobject';

    export default {

        /**
         * The component name
         *
         * @type {String}
         */
        name: 'SignatureRequest',

        /**
         * The component properties
         *
         * @type {Object}
         */
        props: {

            /**
             * The campaign
             */
            campaign: {
                type:     Object,
                required: true,
            },
        },

        /**
         * Data
         *
         * @type {function}
         */
        data() {
            return {
                formSigned:           false,
                submitLoading:        false,
                signedDocumentLink:   null,
                unsignedDocumentLink: null,
                documentLoading:      false,
            };
        },

        /**
         * The component watchers
         *
         * @type {object}
         */
        watch: {

            /**
             * Fetch new document by timeout if form signed
             *
             * @type {function}
             */
            formSigned(val) {
                if (val) {
                    let i = setInterval(() => {
                        this.getDocumentLink();
                        clearInterval(i);
                    }, 400);
                }
            },

            /**
             * On signed document link changed
             *
             * @type {function}
             */
            signedDocumentLink(val) {
                if (val) {
                    this.makeDocumentPreview(val, '.document-embed-signed');
                }
            },

            /**
             * On unsigned document link changed
             *
             * @type {function}
             */
            unsignedDocumentLink(val) {
                if (val) {
                    this.makeDocumentPreview(val, '.document-embed-unsigned');
                }
            },
        },

        /**
         * @type {object}
         */
        methods: {

            /**
             * Show form logic
             *
             * @type {function}
             */
            isFormShown(campaign) {
                return !this.formSigned && !campaign.signed_at;
            },

            /**
             * Submit loading class
             *
             * @type {function}
             */
            isSubmitLoading() {
                return this.submitLoading ? 'is-loading' : '';
            },

            /**
             * Get url open popup and sign document
             *
             * @type {function}
             */
            signEdocument(campaign) {
                this.submitLoading = true;

                this.$http.post(`/contact/${this.$root.contact.id}/edocument/sign`, { campaign_id: campaign.id })
                    .then(response => {
                        if (response.data.url) {
                            const client = new HelloSign({
                                clientId: window.grinEnv.HELLO_SIGN_CLIENT_ID
                            });
                            client.open(response.data.url, {
                                skipDomainVerification: true
                            });
                            client.on('sign', (eventData) => this.handleTemplateCreationEvent(eventData));
                        } else if (response.data.signed === true) {
                            this.$notifyError('This request has already been signed');
                            this.formSigned = true;
                        }
                    })
                    .catch(response => this.handleErrorResponse(response))
                    .then(() => this.submitLoading = false)
                ;
            },

            /**
             * Load signed document link
             * @type {function}
             */
            getDocumentLink() {
                this.documentLoading = true;
                this.$http.post(`/contact/${this.$root.contact.id}/edocument/link`, {
                    campaign_id: this.campaign.id,
                })
                    .then(response => {
                        if (this.formSigned) this.signedDocumentLink = response.data.url;
                        else this.unsignedDocumentLink = response.data.url;
                    })
                    .catch(response => this.handleErrorResponse(response))
                    .then(() => this.documentLoading = false);
            },

            /**
             * Handle error response
             * @type {function}
             */
            handleErrorResponse(response) {
                if (response.status === 403) {
                    this.$notifyError(response.body.message);
                } else {
                    this.$notifyError('Something went wrong, please try again or contact support');
                }
            },

            /**
             * Handling template creation data
             * @type {function}
             */
            handleTemplateCreationEvent(eventData) {
                this.formSigned = true;
                this.$notifySuccess('Signature stored successfully');
            },

            /**
             * Build PDF document preview
             * @type {function}
             */
            makeDocumentPreview(url, element) {
                const options = {
                    pdfOpenParams: {scrollbar: '0', toolbar: '0', statusbar: '0', messages: '0', navpanes: '0'},
                    fallbackLink:  '<p>This browser does not support inline PDFs. Please download the ' +
                        'contract to view it: <a href="[url]">Download Contract</a></p>',
                };
                PDFObject.embed(url, element, options);
            },
        },

        /**
         * When the component is created
         */
        created() {
            if (this.campaign.signed_at) {
                this.formSigned = true;
            }

            this.getDocumentLink();
        },
    };
</script>
